export const emojiPickerIcons = {
    emoji_group_name_1: "Smileys & People",
    emoji_group_list_1: [
                ["😀","Grinning Face"],
                ["😁","Beaming Face With Smiling Eyes"],
                ["😂","Face With Tears of Joy"],
                ["😃","Grinning Face With Big Eyes"],
                ["😄","Grinning Face With Smiling Eyes"],
                ["😅","Grinning Face With Sweat"],
                ["😆","Grinning Squinting Face"],
                ["😉","Winking Face"],
                ["😊","Smiling Face With Smiling Eyes"],
                ["😋","Face Savoring Food"],
                ["😎","Smiling Face With Sunglasses"],
                ["😍","Smiling Face With Heart-Eyes"],
                ["😘","Face Blowing a Kiss"],
                ["😗","Kissing Face"],
                ["😙","Kissing Face With Smiling Eyes"],
                ["😚","Kissing Face With Closed Eyes"],
                ["☺","Smiling Face"],
                ["🙂","Slightly Smiling Face"],
                ["🤗","Hugging Face"],
                ["🤔","Thinking Face"],
                ["😐","Neutral Face"],
                ["😑","Expressionless Face"],
                ["😶","Face Without Mouth"],
                ["🙄","Face With Rolling Eyes"],
                ["😏","Smirking Face"],
                ["😣","Persevering Face"],
                ["😥","Sad but Relieved Face"],
                ["😮","Face With Open Mouth"],
                ["🤐","Zipper-Mouth Face"],
                ["😯","Hushed Face"],
                ["😪","Sleepy Face"],
                ["😫","Tired Face"],
                ["😴","Sleeping Face"],
                ["😌","Relieved Face"],
                ["😛","Face With Tongue"],
                ["😜","Winking Face With Tongue"],
                ["😝","Squinting Face With Tongue"],
                ["😒","Unamused Face"],
                ["😓","Downcast Face With Sweat"],
                ["😔","Pensive Face"],
                ["😕","Confused Face"],
                ["🙃","Upside-Down Face"],
                ["🤑","Money-Mouth Face"],
                ["😲","Astonished Face"],
                ["☹","Frowning Face"],
                ["🙁","Slightly Frowning Face"],
                ["😖","Confounded Face"],
                ["😞","Disappointed Face"],
                ["😟","Worried Face"],
                ["😤","Face With Steam From Nose"],
                ["😢","Crying Face"],
                ["😭","Loudly Crying Face"],
                ["😦","Frowning Face With Open Mouth"],
                ["😧","Anguished Face"],
                ["😨","Fearful Face"],
                ["😩","Weary Face"],
                ["😬","Grimacing Face"],
                ["😰","Anxious Face With Sweat"],
                ["😱","Face Screaming in Fear"],
                ["😳","Flushed Face"],
                ["😵","Dizzy Face"],
                ["😡","Pouting Face"],
                ["😠","Angry Face"],
                ["😷","Face With Medical Mask"],
                ["🤒","Face With Thermometer"],
                ["🤕","Face With Head-Bandage"],
                ["😇","Smiling Face With Halo"],
                ["🤓","Nerd Face"],
                ["😈","Smiling Face With Horns"],
                ["👿","Angry Face With Horns"],
                ["👹","Ogre"],
                ["👺","Goblin"],
                ["💀","Skull"],
                ["☠","Skull and Crossbones"],
                ["👻","Ghost"],
                ["👽","Alien"],
                ["👾","Alien Monster"],
                ["🤖","Robot Face"],
                ["💩","Pile of Poo"],
                ["😺","Grinning Cat Face"],
                ["😸","Grinning Cat Face With Smiling Eyes"],
                ["😹","Cat Face With Tears of Joy"],
                ["😻","Smiling Cat Face With Heart-Eyes"],
                ["😼","Cat Face With Wry Smile"],
                ["😽","Kissing Cat Face"],
                ["🙀","Weary Cat Face"],
                ["😿","Crying Cat Face"],
                ["😾","Pouting Cat Face"],
                ["🙈","See-No-Evil Monkey"],
                ["🙉","Hear-No-Evil Monkey"],
                ["🙊","Speak-No-Evil Monkey"],
                ["👶","Baby"],
                ["👦","Boy"],
                ["👧","Girl"],
                ["👨","Man"],
                ["👩","Woman"],
                ["👴","Old Man"],
                ["👵","Old Woman"],
                ["👮","Police Officer"],
                ["🕵","Detective"],
                ["💂","Guard"],
                ["👷","Construction Worker"],
                ["👸","Princess"],
                ["👳","Person Wearing Turban"],
                ["👲","Man With Chinese Cap"],
                ["👱","Blond-Haired Person"],
                ["👰","Bride With Veil"],
                ["👼","Baby Angel"],
                ["🎅","Santa Claus"],
                ["🙍","Person Frowning"],
                ["🙎","Person Pouting"],
                ["🙅","Person Gesturing No"],
                ["🙆","Person Gesturing OK"],
                ["💁","Person Tipping Hand"],
                ["🙋","Person Raising Hand"],
                ["🙇","Person Bowing"],
                ["💆","Person Getting Massage"],
                ["💇","Person Getting Haircut"],
                ["🚶","Person Walking"],
                ["🏃","Person Running"],
                ["💃","Woman Dancing"],
                ["👯","People With Bunny Ears"],
                ["🛀","Person Taking Bath"],
                ["🛌","Person in Bed"],
                ["🕴","Man in Suit Levitating"],
                ["🗣","Speaking Head"],
                ["👤","Bust in Silhouette"],
                ["👥","Busts in Silhouette"],
                ["🏇","Horse Racing"],
                ["⛷","Skier"],
                ["🏂","Snowboarder"],
                ["🏌","Person Golfing"],
                ["🏄","Person Surfing"],
                ["🚣","Person Rowing Boat"],
                ["🏊","Person Swimming"],
                ["⛹","Person Bouncing Ball"],
                ["🏋","Person Lifting Weights"],
                ["🚴","Person Biking"],
                ["🚵","Person Mountain Biking"],
                ["🏎","Racing Car"],
                ["🏍","Motorcycle"],
                ["👫","Man and Woman Holding Hands"],
                ["👬","Two Men Holding Hands"],
                ["👭","Two Women Holding Hands"],
                ["💏","Kiss"],
                ["💑","Couple With Heart"],
                ["👪","Family"],
                ["💪","Flexed Biceps"],
                ["👈","Backhand Index Pointing Left"],
                ["👉","Backhand Index Pointing Right"],
                ["☝","Index Pointing Up"],
                ["👆","Backhand Index Pointing Up"],
                ["🖕","Middle Finger"],
                ["👇","Backhand Index Pointing Down"],
                ["✌","Victory Hand"],
                ["🖖","Vulcan Salute"],
                ["🤘","Sign of the Horns"],
                ["🖐","Hand With Fingers Splayed"],
                ["✋","Raised Hand"],
                ["👌","OK Hand"],
                ["👍","Thumbs Up"],
                ["👎","Thumbs Down"],
                ["✊","Raised Fist"],
                ["👊","Oncoming Fist"],
                ["👋","Waving Hand"],
                ["✍","Writing Hand"],
                ["👏","Clapping Hands"],
                ["👐","Open Hands"],
                ["🙌","Raising Hands"],
                ["🙏","Folded Hands"],
                ["💅","Nail Polish"],
                ["👂","Ear"],
                ["👃","Nose"],
                ["👣","Footprints"],
                ["👀","Eyes"],
                ["👁","Eye"],
                ["👅","Tongue"],
                ["👄","Mouth"],
                ["💋","Kiss Mark"],
                ["💘","Heart With Arrow"],
                ["❤","Red Heart"],
                ["💓","Beating Heart"],
                ["💔","Broken Heart"],
                ["💕","Two Hearts"],
                ["💖","Sparkling Heart"],
                ["💗","Growing Heart"],
                ["💙","Blue Heart"],
                ["💚","Green Heart"],
                ["💛","Yellow Heart"],
                ["💜","Purple Heart"],
                ["💝","Heart With Ribbon"],
                ["💞","Revolving Hearts"],
                ["💟","Heart Decoration"],
                ["❣","Heavy Heart Exclamation"],
                ["💌","Love Letter"],
                ["💤","Zzz"],
                ["💢","Anger Symbol"],
                ["💣","Bomb"],
                ["💥","Collision"],
                ["💦","Sweat Droplets"],
                ["💨","Dashing Away"],
                ["💫","Dizzy"],
                ["💬","Speech Balloon"],
                ["🗯","Right Anger Bubble"],
                ["💭","Thought Balloon"],
                ["🕳","Hole"],
                ["👓","Glasses"],
                ["🕶","Sunglasses"],
                ["👔","Necktie"],
                ["👕","T-Shirt"],
                ["👖","Jeans"],
                ["👗","Dress"],
                ["👘","Kimono"],
                ["👙","Bikini"],
                ["👚","Woman’s Clothes"],
                ["👛","Purse"],
                ["👜","Handbag"],
                ["👝","Clutch Bag"],
                ["🛍","Shopping Bags"],
                ["🎒","School Backpack"],
                ["👞","Man’s Shoe"],
                ["👟","Running Shoe"],
                ["👠","High-Heeled Shoe"],
                ["👡","Woman’s Sandal"],
                ["👢","Woman’s Boot"],
                ["👑","Crown"],
                ["👒","Woman’s Hat"],
                ["🎩","Top Hat"],
                ["🎓","Graduation Cap"],
                ["⛑","Rescue Worker’s Helmet"],
                ["📿","Prayer Beads"],
                ["💄","Lipstick"],
                ["💍","Ring"],
                ["💎","Gem Stone"]
            ],
    emoji_group_name_2: "Animals & Nature",
    emoji_group_list_2: [
        ["🐵","Monkey Face"],
        ["🐒","Monkey"],
        ["🐶","Dog Face"],
        ["🐕","Dog"],
        ["🐩","Poodle"],
        ["🐺","Wolf Face"],
        ["🐱","Cat Face"],
        ["🐈","Cat"],
        ["🦁","Lion Face"],
        ["🐯","Tiger Face"],
        ["🐅","Tiger"],
        ["🐆","Leopard"],
        ["🐴","Horse Face"],
        ["🐎","Horse"],
        ["🦄","Unicorn Face"],
        ["🐮","Cow Face"],
        ["🐂","Ox"],
        ["🐃","Water Buffalo"],
        ["🐄","Cow"],
        ["🐷","Pig Face"],
        ["🐖","Pig"],
        ["🐗","Boar"],
        ["🐽","Pig Nose"],
        ["🐏","Ram"],
        ["🐑","Ewe"],
        ["🐐","Goat"],
        ["🐪","Camel"],
        ["🐫","Two-Hump Camel"],
        ["🐘","Elephant"],
        ["🐭","Mouse Face"],
        ["🐁","Mouse"],
        ["🐀","Rat"],
        ["🐹","Hamster Face"],
        ["🐰","Rabbit Face"],
        ["🐇","Rabbit"],
        ["🐿","Chipmunk"],
        ["🐻","Bear Face"],
        ["🐨","Koala"],
        ["🐼","Panda Face"],
        ["🐾","Paw Prints"],
        ["🦃","Turkey"],
        ["🐔","Chicken"],
        ["🐓","Rooster"],
        ["🐣","Hatching Chick"],
        ["🐤","Baby Chick"],
        ["🐥","Front-Facing Baby Chick"],
        ["🐦","Bird"],
        ["🐧","Penguin"],
        ["🕊","Dove"],
        ["🐸","Frog Face"],
        ["🐊","Crocodile"],
        ["🐢","Turtle"],
        ["🐍","Snake"],
        ["🐲","Dragon Face"],
        ["🐉","Dragon"],
        ["🐳","Spouting Whale"],
        ["🐋","Whale"],
        ["🐬","Dolphin"],
        ["🐟","Fish"],
        ["🐠","Tropical Fish"],
        ["🐡","Blowfish"],
        ["🐙","Octopus"],
        ["🐚","Spiral Shell"],
        ["🦀","Crab"],
        ["🐌","Snail"],
        ["🐛","Bug"],
        ["🐜","Ant"],
        ["🐝","Honeybee"],
        ["🐞","Lady Beetle"],
        ["🕷","Spider"],
        ["🕸","Spider Web"],
        ["🦂","Scorpion"],
        ["💐","Bouquet"],
        ["🌸","Cherry Blossom"],
        ["💮","White Flower"],
        ["🏵","Rosette"],
        ["🌹","Rose"],
        ["🌺","Hibiscus"],
        ["🌻","Sunflower"],
        ["🌼","Blossom"],
        ["🌷","Tulip"],
        ["🌱","Seedling"],
        ["🌲","Evergreen Tree"],
        ["🌳","Deciduous Tree"],
        ["🌴","Palm Tree"],
        ["🌵","Cactus"],
        ["🌾","Sheaf of Rice"],
        ["🌿","Herb"],
        ["☘","Shamrock"],
        ["🍀","Four Leaf Clover"],
        ["🍁","Maple Leaf"],
        ["🍂","Fallen Leaf"],
        ["🍃","Leaf Fluttering in Wind"]
    ],
    emoji_group_name_3: "Food & Drink",
    emoji_group_list_3: [
        ["🍇","Grapes"],
        ["🍈","Melon"],
        ["🍉","Watermelon"],
        ["🍊","Tangerine"],
        ["🍋","Lemon"],
        ["🍌","Banana"],
        ["🍍","Pineapple"],
        ["🍎","Red Apple"],
        ["🍏","Green Apple"],
        ["🍐","Pear"],
        ["🍑","Peach"],
        ["🍒","Cherries"],
        ["🍓","Strawberry"],
        ["🍅","Tomato"],
        ["🍆","Eggplant"],
        ["🌽","Ear of Corn"],
        ["🌶","Hot Pepper"],
        ["🍄","Mushroom"],
        ["🌰","Chestnut"],
        ["🍞","Bread"],
        ["🧀","Cheese Wedge"],
        ["🍖","Meat on Bone"],
        ["🍗","Poultry Leg"],
        ["🍔","Hamburger"],
        ["🍟","French Fries"],
        ["🍕","Pizza"],
        ["🌭","Hot Dog"],
        ["🌮","Taco"],
        ["🌯","Burrito"],
        ["🍳","Cooking"],
        ["🍲","Pot of Food"],
        ["🍿","Popcorn"],
        ["🍱","Bento Box"],
        ["🍘","Rice Cracker"],
        ["🍙","Rice Ball"],
        ["🍚","Cooked Rice"],
        ["🍛","Curry Rice"],
        ["🍜","Steaming Bowl"],
        ["🍝","Spaghetti"],
        ["🍠","Roasted Sweet Potato"],
        ["🍢","Oden"],
        ["🍣","Sushi"],
        ["🍤","Fried Shrimp"],
        ["🍥","Fish Cake With Swirl"],
        ["🍡","Dango"],
        ["🍦","Soft Ice Cream"],
        ["🍧","Shaved Ice"],
        ["🍨","Ice Cream"],
        ["🍩","Doughnut"],
        ["🍪","Cookie"],
        ["🎂","Birthday Cake"],
        ["🍰","Shortcake"],
        ["🍫","Chocolate Bar"],
        ["🍬","Candy"],
        ["🍭","Lollipop"],
        ["🍮","Custard"],
        ["🍯","Honey Pot"],
        ["🍼","Baby Bottle"],
        ["☕","Hot Beverage"],
        ["🍵","Teacup Without Handle"],
        ["🍶","Sake"],
        ["🍾","Bottle With Popping Cork"],
        ["🍷","Wine Glass"],
        ["🍸","Cocktail Glass"],
        ["🍹","Tropical Drink"],
        ["🍺","Beer Mug"],
        ["🍻","Clinking Beer Mugs"],
        ["🍽","Fork and Knife With Plate"],
        ["🍴","Fork and Knife"],
        ["🔪","Kitchen Knife"],
        ["🏺","Amphora"]
    ],
    emoji_group_name_4: "Activity",
    emoji_group_list_4: [
        ["🎃","Jack-O-Lantern"],
        ["🎄","Christmas Tree"],
        ["🎆","Fireworks"],
        ["🎇","Sparkler"],
        ["✨","Sparkles"],
        ["🎈","Balloon"],
        ["🎉","Party Popper"],
        ["🎊","Confetti Ball"],
        ["🎋","Tanabata Tree"],
        ["🎍","Pine Decoration"],
        ["🎎","Japanese Dolls"],
        ["🎏","Carp Streamer"],
        ["🎐","Wind Chime"],
        ["🎑","Moon Viewing Ceremony"],
        ["🎀","Ribbon"],
        ["🎁","Wrapped Gift"],
        ["🎗","Reminder Ribbon"],
        ["🎟","Admission Tickets"],
        ["🎫","Ticket"],
        ["🎖","Military Medal"],
        ["🏆","Trophy"],
        ["🏅","Sports Medal"],
        ["⚽","Soccer Ball"],
        ["⚾","Baseball"],
        ["🏀","Basketball"],
        ["🏐","Volleyball"],
        ["🏈","American Football"],
        ["🏉","Rugby Football"],
        ["🎾","Tennis"],
        ["🎳","Bowling"],
        ["🏏","Cricket Game"],
        ["🏑","Field Hockey"],
        ["🏒","Ice Hockey"],
        ["🏓","Ping Pong"],
        ["🏸","Badminton"],
        ["⛳","Flag in Hole"],
        ["⛸","Ice Skate"],
        ["🎣","Fishing Pole"],
        ["🎽","Running Shirt"],
        ["🎿","Skis"],
        ["🎯","Direct Hit"],
        ["🎱","Pool 8 Ball"],
        ["🔮","Crystal Ball"],
        ["🎮","Video Game"],
        ["🕹","Joystick"],
        ["🎰","Slot Machine"],
        ["🎲","Game Die"],
        ["♠","Spade Suit"],
        ["♥","Heart Suit"],
        ["♦","Diamond Suit"],
        ["♣","Club Suit"],
        ["🃏","Joker"],
        ["🀄","Mahjong Red Dragon"],
        ["🎴","Flower Playing Cards"],
        ["🎭","Performing Arts"],
        ["🖼","Framed Picture"],
        ["🎨","Artist Palette"]
    ],
    emoji_group_name_5: "Travel & Places",
    emoji_group_list_5: [
        ["🌍","Globe Showing Europe-Africa"],
        ["🌎","Globe Showing Americas"],
        ["🌏","Globe Showing Asia-Australia"],
        ["🌐","Globe With Meridians"],
        ["🗺","World Map"],
        ["🗾","Map of Japan"],
        ["🏔","Snow-Capped Mountain"],
        ["⛰","Mountain"],
        ["🌋","Volcano"],
        ["🗻","Mount Fuji"],
        ["🏕","Camping"],
        ["🏖","Beach With Umbrella"],
        ["🏜","Desert"],
        ["🏝","Desert Island"],
        ["🏞","National Park"],
        ["🏟","Stadium"],
        ["🏛","Classical Building"],
        ["🏗","Building Construction"],
        ["🏘","Houses"],
        ["🏚","Derelict House"],
        ["🏠","House"],
        ["🏡","House With Garden"],
        ["🏢","Office Building"],
        ["🏣","Japanese Post Office"],
        ["🏤","Post Office"],
        ["🏥","Hospital"],
        ["🏦","Bank"],
        ["🏨","Hotel"],
        ["🏩","Love Hotel"],
        ["🏪","Convenience Store"],
        ["🏫","School"],
        ["🏬","Department Store"],
        ["🏭","Factory"],
        ["🏯","Japanese Castle"],
        ["🏰","Castle"],
        ["💒","Wedding"],
        ["🗼","Tokyo Tower"],
        ["🗽","Statue of Liberty"],
        ["⛪","Church"],
        ["🕌","Mosque"],
        ["🕍","Synagogue"],
        ["⛩","Shinto Shrine"],
        ["🕋","Kaaba"],
        ["⛲","Fountain"],
        ["⛺","Tent"],
        ["🌁","Foggy"],
        ["🌃","Night With Stars"],
        ["🏙","Cityscape"],
        ["🌄","Sunrise Over Mountains"],
        ["🌅","Sunrise"],
        ["🌆","Cityscape at Dusk"],
        ["🌇","Sunset"],
        ["🌉","Bridge at Night"],
        ["♨","Hot Springs"],
        ["🌌","Milky Way"],
        ["🎠","Carousel Horse"],
        ["🎡","Ferris Wheel"],
        ["🎢","Roller Coaster"],
        ["💈","Barber Pole"],
        ["🎪","Circus Tent"],
        ["🚂","Locomotive"],
        ["🚃","Railway Car"],
        ["🚄","High-Speed Train"],
        ["🚅","Bullet Train"],
        ["🚆","Train"],
        ["🚇","Metro"],
        ["🚈","Light Rail"],
        ["🚉","Station"],
        ["🚊","Tram"],
        ["🚝","Monorail"],
        ["🚞","Mountain Railway"],
        ["🚋","Tram Car"],
        ["🚌","Bus"],
        ["🚍","Oncoming Bus"],
        ["🚎","Trolleybus"],
        ["🚐","Minibus"],
        ["🚑","Ambulance"],
        ["🚒","Fire Engine"],
        ["🚓","Police Car"],
        ["🚔","Oncoming Police Car"],
        ["🚕","Taxi"],
        ["🚖","Oncoming Taxi"],
        ["🚗","Automobile"],
        ["🚘","Oncoming Automobile"],
        ["🚙","Sport Utility Vehicle"],
        ["🚚","Delivery Truck"],
        ["🚛","Articulated Lorry"],
        ["🚜","Tractor"],
        ["🚲","Bicycle"],
        ["🚏","Bus Stop"],
        ["🛣","Motorway"],
        ["🛤","Railway Track"],
        ["🛢","Oil Drum"],
        ["⛽","Fuel Pump"],
        ["🚨","Police Car Light"],
        ["🚥","Horizontal Traffic Light"],
        ["🚦","Vertical Traffic Light"],
        ["🚧","Construction"],
        ["⚓","Anchor"],
        ["⛵","Sailboat"],
        ["🚤","Speedboat"],
        ["🛳","Passenger Ship"],
        ["⛴","Ferry"],
        ["🛥","Motor Boat"],
        ["🚢","Ship"],
        ["✈","Airplane"],
        ["🛩","Small Airplane"],
        ["🛫","Airplane Departure"],
        ["🛬","Airplane Arrival"],
        ["💺","Seat"],
        ["🚁","Helicopter"],
        ["🚟","Suspension Railway"],
        ["🚠","Mountain Cableway"],
        ["🚡","Aerial Tramway"],
        ["🛰","Satellite"],
        ["🚀","Rocket"],
        ["🛎","Bellhop Bell"],
        ["⌛","Hourglass Done"],
        ["⏳","Hourglass Not Done"],
        ["⌚","Watch"],
        ["⏰","Alarm Clock"],
        ["⏱","Stopwatch"],
        ["⏲","Timer Clock"],
        ["🕰","Mantelpiece Clock"],
        ["🕛","Twelve O’clock"],
        ["🕧","Twelve-Thirty"],
        ["🕐","One O’clock"],
        ["🕜","One-Thirty"],
        ["🕑","Two O’clock"],
        ["🕝","Two-Thirty"],
        ["🕒","Three O’clock"],
        ["🕞","Three-Thirty"],
        ["🕓","Four O’clock"],
        ["🕟","Four-Thirty"],
        ["🕔","Five O’clock"],
        ["🕠","Five-Thirty"],
        ["🕕","Six O’clock"],
        ["🕡","Six-Thirty"],
        ["🕖","Seven O’clock"],
        ["🕢","Seven-Thirty"],
        ["🕗","Eight O’clock"],
        ["🕣","Eight-Thirty"],
        ["🕘","Nine O’clock"],
        ["🕤","Nine-Thirty"],
        ["🕙","Ten O’clock"],
        ["🕥","Ten-Thirty"],
        ["🕚","Eleven O’clock"],
        ["🕦","Eleven-Thirty"],
        ["🌑","New Moon"],
        ["🌒","Waxing Crescent Moon"],
        ["🌓","First Quarter Moon"],
        ["🌔","Waxing Gibbous Moon"],
        ["🌕","Full Moon"],
        ["🌖","Waning Gibbous Moon"],
        ["🌗","Last Quarter Moon"],
        ["🌘","Waning Crescent Moon"],
        ["🌙","Crescent Moon"],
        ["🌚","New Moon Face"],
        ["🌛","First Quarter Moon Face"],
        ["🌜","Last Quarter Moon Face"],
        ["🌡","Thermometer"],
        ["☀","Sun"],
        ["🌝","Full Moon Face"],
        ["🌞","Sun With Face"],
        ["⭐","White Medium Star"],
        ["🌟","Glowing Star"],
        ["🌠","Shooting Star"],
        ["☁","Cloud"],
        ["⛅","Sun Behind Cloud"],
        ["⛈","Cloud With Lightning and Rain"],
        ["🌤","Sun Behind Small Cloud"],
        ["🌥","Sun Behind Large Cloud"],
        ["🌦","Sun Behind Rain Cloud"],
        ["🌧","Cloud With Rain"],
        ["🌨","Cloud With Snow"],
        ["🌩","Cloud With Lightning"],
        ["🌪","Tornado"],
        ["🌫","Fog"],
        ["🌬","Wind Face"],
        ["🌀","Cyclone"],
        ["🌈","Rainbow"],
        ["🌂","Closed Umbrella"],
        ["☂","Umbrella"],
        ["☔","Umbrella With Rain Drops"],
        ["⛱","Umbrella on Ground"],
        ["⚡","High Voltage"],
        ["❄","Snowflake"],
        ["☃","Snowman"],
        ["⛄","Snowman Without Snow"],
        ["☄","Comet"],
        ["🔥","Fire"],
        ["💧","Droplet"],
        ["🌊","Water Wave"]
    ],
    emoji_group_name_6: "Objects",
    emoji_group_list_6: [
        ["🔇","Muted Speaker"],
        ["🔈","Speaker Low Volume"],
        ["🔉","Speaker Medium Volume"],
        ["🔊","Speaker High Volume"],
        ["📢","Loudspeaker"],
        ["📣","Megaphone"],
        ["📯","Postal Horn"],
        ["🔔","Bell"],
        ["🔕","Bell With Slash"],
        ["🎼","Musical Score"],
        ["🎵","Musical Note"],
        ["🎶","Musical Notes"],
        ["🎙","Studio Microphone"],
        ["🎚","Level Slider"],
        ["🎛","Control Knobs"],
        ["🎤","Microphone"],
        ["🎧","Headphone"],
        ["📻","Radio"],
        ["🎷","Saxophone"],
        ["🎸","Guitar"],
        ["🎹","Musical Keyboard"],
        ["🎺","Trumpet"],
        ["🎻","Violin"],
        ["📱","Mobile Phone"],
        ["📲","Mobile Phone With Arrow"],
        ["☎","Telephone"],
        ["📞","Telephone Receiver"],
        ["📟","Pager"],
        ["📠","Fax Machine"],
        ["🔋","Battery"],
        ["🔌","Electric Plug"],
        ["💻","Laptop Computer"],
        ["🖥","Desktop Computer"],
        ["🖨","Printer"],
        ["⌨","Keyboard"],
        ["🖱","Computer Mouse"],
        ["🖲","Trackball"],
        ["💽","Computer Disk"],
        ["💾","Floppy Disk"],
        ["💿","Optical Disk"],
        ["📀","DVD"],
        ["🎥","Movie Camera"],
        ["🎞","Film Frames"],
        ["📽","Film Projector"],
        ["🎬","Clapper Board"],
        ["📺","Television"],
        ["📷","Camera"],
        ["📸","Camera With Flash"],
        ["📹","Video Camera"],
        ["📼","Videocassette"],
        ["🔍","Magnifying Glass Tilted Left"],
        ["🔎","Magnifying Glass Tilted Right"],
        ["🕯","Candle"],
        ["💡","Light Bulb"],
        ["🔦","Flashlight"],
        ["🏮","Red Paper Lantern"],
        ["📔","Notebook With Decorative Cover"],
        ["📕","Closed Book"],
        ["📖","Open Book"],
        ["📗","Green Book"],
        ["📘","Blue Book"],
        ["📙","Orange Book"],
        ["📚","Books"],
        ["📓","Notebook"],
        ["📒","Ledger"],
        ["📃","Page With Curl"],
        ["📜","Scroll"],
        ["📄","Page Facing Up"],
        ["📰","Newspaper"],
        ["🗞","Rolled-Up Newspaper"],
        ["📑","Bookmark Tabs"],
        ["🔖","Bookmark"],
        ["🏷","Label"],
        ["💰","Money Bag"],
        ["💴","Yen Banknote"],
        ["💵","Dollar Banknote"],
        ["💶","Euro Banknote"],
        ["💷","Pound Banknote"],
        ["💸","Money With Wings"],
        ["💳","Credit Card"],
        ["💹","Chart Increasing With Yen"],
        ["💱","Currency Exchange"],
        ["💲","Heavy Dollar Sign"],
        ["✉","Envelope"],
        ["📧","E-Mail"],
        ["📨","Incoming Envelope"],
        ["📩","Envelope With Arrow"],
        ["📤","Outbox Tray"],
        ["📥","Inbox Tray"],
        ["📦","Package"],
        ["📫","Closed Mailbox With Raised Flag"],
        ["📪","Closed Mailbox With Lowered Flag"],
        ["📬","Open Mailbox With Raised Flag"],
        ["📭","Open Mailbox With Lowered Flag"],
        ["📮","Postbox"],
        ["🗳","Ballot Box With Ballot"],
        ["✏","Pencil"],
        ["✒","Black Nib"],
        ["🖋","Fountain Pen"],
        ["🖊","Pen"],
        ["🖌","Paintbrush"],
        ["🖍","Crayon"],
        ["📝","Memo"],
        ["💼","Briefcase"],
        ["📁","File Folder"],
        ["📂","Open File Folder"],
        ["🗂","Card Index Dividers"],
        ["📅","Calendar"],
        ["📆","Tear-Off Calendar"],
        ["🗒","Spiral Notepad"],
        ["🗓","Spiral Calendar"],
        ["📇","Card Index"],
        ["📈","Chart Increasing"],
        ["📉","Chart Decreasing"],
        ["📊","Bar Chart"],
        ["📋","Clipboard"],
        ["📌","Pushpin"],
        ["📍","Round Pushpin"],
        ["📎","Paperclip"],
        ["🖇","Linked Paperclips"],
        ["📏","Straight Ruler"],
        ["📐","Triangular Ruler"],
        ["✂","Scissors"],
        ["🗃","Card File Box"],
        ["🗄","File Cabinet"],
        ["🗑","Wastebasket"],
        ["🔒","Locked"],
        ["🔓","Unlocked"],
        ["🔏","Locked With Pen"],
        ["🔐","Locked With Key"],
        ["🔑","Key"],
        ["🗝","Old Key"],
        ["🔨","Hammer"],
        ["⛏","Pick"],
        ["⚒","Hammer and Pick"],
        ["🛠","Hammer and Wrench"],
        ["🗡","Dagger"],
        ["⚔","Crossed Swords"],
        ["🔫","Pistol"],
        ["🏹","Bow and Arrow"],
        ["🛡","Shield"],
        ["🔧","Wrench"],
        ["🔩","Nut and Bolt"],
        ["⚙","Gear"],
        ["🗜","Clamp"],
        ["⚖","Balance Scale"],
        ["🔗","Link"],
        ["⛓","Chains"],
        ["⚗","Alembic"],
        ["🔬","Microscope"],
        ["🔭","Telescope"],
        ["📡","Satellite Antenna"],
        ["💉","Syringe"],
        ["💊","Pill"],
        ["🚪","Door"],
        ["🛏","Bed"],
        ["🛋","Couch and Lamp"],
        ["🚽","Toilet"],
        ["🚿","Shower"],
        ["🛁","Bathtub"],
        ["🚬","Cigarette"],
        ["⚰","Coffin"],
        ["⚱","Funeral Urn"],
        ["🗿","Moai"]
    ],
    emoji_group_name_7: "Symbols",
    emoji_group_list_7: [
        ["🏧","Atm Sign"],
        ["🚮","Litter in Bin Sign"],
        ["🚰","Potable Water"],
        ["♿","Wheelchair Symbol"],
        ["🚹","Men’s Room"],
        ["🚺","Women’s Room"],
        ["🚻","Restroom"],
        ["🚼","Baby Symbol"],
        ["🚾","Water Closet"],
        ["🛂","Passport Control"],
        ["🛃","Customs"],
        ["🛄","Baggage Claim"],
        ["🛅","Left Luggage"],
        ["⚠","Warning"],
        ["🚸","Children Crossing"],
        ["⛔","No Entry"],
        ["🚫","Prohibited"],
        ["🚳","No Bicycles"],
        ["🚭","No Smoking"],
        ["🚯","No Littering"],
        ["🚱","Non-Potable Water"],
        ["🚷","No Pedestrians"],
        ["📵","No Mobile Phones"],
        ["🔞","No One Under Eighteen"],
        ["☢","Radioactive"],
        ["☣","Biohazard"],
        ["⬆","Up Arrow"],
        ["↗","Up-Right Arrow"],
        ["➡","Right Arrow"],
        ["↘","Down-Right Arrow"],
        ["⬇","Down Arrow"],
        ["↙","Down-Left Arrow"],
        ["⬅","Left Arrow"],
        ["↖","Up-Left Arrow"],
        ["↕","Up-Down Arrow"],
        ["↔","Left-Right Arrow"],
        ["↩","Right Arrow Curving Left"],
        ["↪","Left Arrow Curving Right"],
        ["⤴","Right Arrow Curving Up"],
        ["⤵","Right Arrow Curving Down"],
        ["🔃","Clockwise Vertical Arrows"],
        ["🔄","Counterclockwise Arrows Button"],
        ["🔙","Back Arrow"],
        ["🔚","End Arrow"],
        ["🔛","On! Arrow"],
        ["🔜","Soon Arrow"],
        ["🔝","Top Arrow"],
        ["🛐","Place of Worship"],
        ["⚛","Atom Symbol"],
        ["🕉","Om"],
        ["✡","Star of David"],
        ["☸","Wheel of Dharma"],
        ["☯","Yin Yang"],
        ["✝","Latin Cross"],
        ["☦","Orthodox Cross"],
        ["☪","Star and Crescent"],
        ["☮","Peace Symbol"],
        ["🕎","Menorah"],
        ["🔯","Dotted Six-Pointed Star"],
        ["♈","Aries"],
        ["♉","Taurus"],
        ["♊","Gemini"],
        ["♋","Cancer"],
        ["♌","Leo"],
        ["♍","Virgo"],
        ["♎","Libra"],
        ["♏","Scorpio"],
        ["♐","Sagittarius"],
        ["♑","Capricorn"],
        ["♒","Aquarius"],
        ["♓","Pisces"],
        ["⛎","Ophiuchus"],
        ["🔀","Shuffle Tracks Button"],
        ["🔁","Repeat Button"],
        ["🔂","Repeat Single Button"],
        ["▶","Play Button"],
        ["⏩","Fast-Forward Button"],
        ["⏭","Next Track Button"],
        ["⏯","Play or Pause Button"],
        ["◀","Reverse Button"],
        ["⏪","Fast Reverse Button"],
        ["⏮","Last Track Button"],
        ["🔼","Upwards Button"],
        ["⏫","Fast Up Button"],
        ["🔽","Downwards Button"],
        ["⏬","Fast Down Button"],
        ["⏸","Pause Button"],
        ["⏹","Stop Button"],
        ["⏺","Record Button"],
        ["⏏","Eject Button"],
        ["🎦","Cinema"],
        ["🔅","Dim Button"],
        ["🔆","Bright Button"],
        ["📶","Antenna Bars"],
        ["📳","Vibration Mode"],
        ["📴","Mobile Phone Off"],
        ["♻","Recycling Symbol"],
        ["⚜","Fleur-De-Lis"],
        ["🔱","Trident Emblem"],
        ["📛","Name Badge"],
        ["🔰","Japanese Symbol for Beginner"],
        ["⭕","Heavy Large Circle"],
        ["✅","White Heavy Check Mark"],
        ["☑","Ballot Box With Check"],
        ["✔","Heavy Check Mark"],
        ["✖","Heavy Multiplication X"],
        ["❌","Cross Mark"],
        ["❎","Cross Mark Button"],
        ["➕","Heavy Plus Sign"],
        ["➖","Heavy Minus Sign"],
        ["➗","Heavy Division Sign"],
        ["➰","Curly Loop"],
        ["➿","Double Curly Loop"],
        ["〽","Part Alternation Mark"],
        ["✳","Eight-Spoked Asterisk"],
        ["✴","Eight-Pointed Star"],
        ["❇","Sparkle"],
        ["‼","Double Exclamation Mark"],
        ["⁉","Exclamation Question Mark"],
        ["❓","Question Mark"],
        ["❔","White Question Mark"],
        ["❕","White Exclamation Mark"],
        ["❗","Exclamation Mark"],
        ["〰",""],
        ["©","Copyright"],
        ["®","Registered"],
        ["™","Trade Mark"],
        ["🔟","Keycap 10"],
        ["💯","Hundred Points"],
        ["🔠","Input Latin Uppercase"],
        ["🔡","Input Latin Lowercase"],
        ["🔢","Input Numbers"],
        ["🔣","Input Symbols"],
        ["🔤","Input Latin Letters"],
        ["🅰","A Button (blood Type)"],
        ["🆎","Ab Button (blood Type)"],
        ["🅱","B Button (blood Type)"],
        ["🆑","CL Button"],
        ["🆒","Cool Button"],
        ["🆓","Free Button"],
        ["ℹ","Information"],
        ["🆔","ID Button"],
        ["Ⓜ","Circled M"],
        ["🆕","New Button"],
        ["🆖","NG Button"],
        ["🅾","O Button (blood Type)"],
        ["🆗","OK Button"],
        ["🅿","P Button"],
        ["🆘","SOS Button"],
        ["🆙","Up! Button"],
        ["🆚","Vs Button"],
        ["🈁","Japanese “here” Button"],
        ["🈂","Japanese “service Charge” Button"],
        ["🈷","Japanese “monthly Amount” Button"],
        ["🈶","Japanese “not Free of Charge” Button"],
        ["🈯","Japanese “reserved” Button"],
        ["🉐","Japanese “bargain” Button"],
        ["🈹","Japanese “discount” Button"],
        ["🈚","Japanese “free of Charge” Button"],
        ["🈲","Japanese “prohibited” Button"],
        ["🉑","Japanese “acceptable” Button"],
        ["🈸","Japanese “application” Button"],
        ["🈴","Japanese “passing Grade” Button"],
        ["🈳","Japanese “vacancy” Button"],
        ["㊗","Japanese “congratulations” Button"],
        ["㊙","Japanese “secret” Button"],
        ["🈺","Japanese “open for Business” Button"],
        ["🈵","Japanese “no Vacancy” Button"],
        ["▪","Black Small Square"],
        ["▫","White Small Square"],
        ["◻","White Medium Square"],
        ["◼","Black Medium Square"],
        ["◽","White Medium-Small Square"],
        ["◾","Black Medium-Small Square"],
        ["⬛","Black Large Square"],
        ["⬜","White Large Square"],
        ["🔶","Large Orange Diamond"],
        ["🔷","Large Blue Diamond"],
        ["🔸","Small Orange Diamond"],
        ["🔹","Small Blue Diamond"],
        ["🔺","Red Triangle Pointed Up"],
        ["🔻","Red Triangle Pointed Down"],
        ["💠","Diamond With a Dot"],
        ["🔘","Radio Button"],
        ["🔲","Black Square Button"],
        ["🔳","White Square Button"],
        ["⚪","White Circle"],
        ["⚫","Black Circle"],
        ["🔴","Red Circle"],
        ["🔵","Blue Circle"]
    ],
    emoji_group_name_8: "Flags",
    emoji_group_list_8: [
        ["🏁","Chequered Flag"],
        ["🚩","Triangular Flag"],
        ["🎌","Crossed Flags"],
        ["🏴","Black Flag"],
        ["🏳","White Flag"],
        ["🇦🇨","Ascension Island"],
        ["🇦🇩","Andorra"],
        ["🇦🇪","United Arab Emirates"],
        ["🇦🇫","Afghanistan"],
        ["🇦🇬","Antigua & Barbuda"],
        ["🇦🇮","Anguilla"],
        ["🇦🇱","Albania"],
        ["🇦🇲","Armenia"],
        ["🇦🇴","Angola"],
        ["🇦🇶","Antarctica"],
        ["🇦🇷","Argentina"],
        ["🇦🇸","American Samoa"],
        ["🇦🇹","Austria"],
        ["🇦🇺","Australia"],
        ["🇦🇼","Aruba"],
        ["🇦🇽","Åland Islands"],
        ["🇦🇿","Azerbaijan"],
        ["🇧🇦","Bosnia & Herzegovina"],
        ["🇧🇧","Barbados"],
        ["🇧🇩","Bangladesh"],
        ["🇧🇪","Belgium"],
        ["🇧🇫","Burkina Faso"],
        ["🇧🇬","Bulgaria"],
        ["🇧🇭","Bahrain"],
        ["🇧🇮","Burundi"],
        ["🇧🇯","Benin"],
        ["🇧🇱","St. Barthélemy"],
        ["🇧🇲","Bermuda"],
        ["🇧🇳","Brunei"],
        ["🇧🇴","Bolivia"],
        ["🇧🇶","Caribbean Netherlands"],
        ["🇧🇷","Brazil"],
        ["🇧🇸","Bahamas"],
        ["🇧🇹","Bhutan"],
        ["🇧🇻","Bouvet Island"],
        ["🇧🇼","Botswana"],
        ["🇧🇾","Belarus"],
        ["🇧🇿","Belize"],
        ["🇨🇦","Canada"],
        ["🇨🇨","Cocos (Keeling) Islands"],
        ["🇨🇩","Congo - Kinshasa"],
        ["🇨🇫","Central African Republic"],
        ["🇨🇬","Congo - Brazzaville"],
        ["🇨🇭","Switzerland"],
        ["🇨🇮","Côte D’Ivoire"],
        ["🇨🇰","Cook Islands"],
        ["🇨🇱","Chile"],
        ["🇨🇲","Cameroon"],
        ["🇨🇳","China"],
        ["🇨🇴","Colombia"],
        ["🇨🇵","Clipperton Island"],
        ["🇨🇷","Costa Rica"],
        ["🇨🇺","Cuba"],
        ["🇨🇻","Cape Verde"],
        ["🇨🇼","Curaçao"],
        ["🇨🇽","Christmas Island"],
        ["🇨🇾","Cyprus"],
        ["🇨🇿","Czechia"],
        ["🇩🇪","Germany"],
        ["🇩🇬","Diego Garcia"],
        ["🇩🇯","Djibouti"],
        ["🇩🇰","Denmark"],
        ["🇩🇲","Dominica"],
        ["🇩🇴","Dominican Republic"],
        ["🇩🇿","Algeria"],
        ["🇪🇦","Ceuta & Melilla"],
        ["🇪🇨","Ecuador"],
        ["🇪🇪","Estonia"],
        ["🇪🇬","Egypt"],
        ["🇪🇭","Western Sahara"],
        ["🇪🇷","Eritrea"],
        ["🇪🇸","Spain"],
        ["🇪🇹","Ethiopia"],
        ["🇪🇺","European Union"],
        ["🇫🇮","Finland"],
        ["🇫🇯","Fiji"],
        ["🇫🇰","Falkland Islands"],
        ["🇫🇲","Micronesia"],
        ["🇫🇴","Faroe Islands"],
        ["🇫🇷","France"],
        ["🇬🇦","Gabon"],
        ["🇬🇧","United Kingdom"],
        ["🇬🇩","Grenada"],
        ["🇬🇪","Georgia"],
        ["🇬🇫","French Guiana"],
        ["🇬🇬","Guernsey"],
        ["🇬🇭","Ghana"],
        ["🇬🇮","Gibraltar"],
        ["🇬🇱","Greenland"],
        ["🇬🇲","Gambia"],
        ["🇬🇳","Guinea"],
        ["🇬🇵","Guadeloupe"],
        ["🇬🇶","Equatorial Guinea"],
        ["🇬🇷","Greece"],
        ["🇬🇸","South Georgia & South Sandwich Islands"],
        ["🇬🇹","Guatemala"],
        ["🇬🇺","Guam"],
        ["🇬🇼","Guinea-Bissau"],
        ["🇬🇾","Guyana"],
        ["🇭🇰","Hong Kong SAR China"],
        ["🇭🇲","Heard & McDonald Islands"],
        ["🇭🇳","Honduras"],
        ["🇭🇷","Croatia"],
        ["🇭🇹","Haiti"],
        ["🇭🇺","Hungary"],
        ["🇮🇨","Canary Islands"],
        ["🇮🇩","Indonesia"],
        ["🇮🇪","Ireland"],
        ["🇮🇱","Israel"],
        ["🇮🇲","Isle of Man"],
        ["🇮🇳","India"],
        ["🇮🇴","British Indian Ocean Territory"],
        ["🇮🇶","Iraq"],
        ["🇮🇷","Iran"],
        ["🇮🇸","Iceland"],
        ["🇮🇹","Italy"],
        ["🇯🇪","Jersey"],
        ["🇯🇲","Jamaica"],
        ["🇯🇴","Jordan"],
        ["🇯🇵","Japan"],
        ["🇰🇪","Kenya"],
        ["🇰🇬","Kyrgyzstan"],
        ["🇰🇭","Cambodia"],
        ["🇰🇮","Kiribati"],
        ["🇰🇲","Comoros"],
        ["🇰🇳","St. Kitts & Nevis"],
        ["🇰🇵","North Korea"],
        ["🇰🇷","South Korea"],
        ["🇰🇼","Kuwait"],
        ["🇰🇾","Cayman Islands"],
        ["🇰🇿","Kazakhstan"],
        ["🇱🇦","Laos"],
        ["🇱🇧","Lebanon"],
        ["🇱🇨","St. Lucia"],
        ["🇱🇮","Liechtenstein"],
        ["🇱🇰","Sri Lanka"],
        ["🇱🇷","Liberia"],
        ["🇱🇸","Lesotho"],
        ["🇱🇹","Lithuania"],
        ["🇱🇺","Luxembourg"],
        ["🇱🇻","Latvia"],
        ["🇱🇾","Libya"],
        ["🇲🇦","Morocco"],
        ["🇲🇨","Monaco"],
        ["🇲🇩","Moldova"],
        ["🇲🇪","Montenegro"],
        ["🇲🇫","St. Martin"],
        ["🇲🇬","Madagascar"],
        ["🇲🇭","Marshall Islands"],
        ["🇲🇰","Macedonia"],
        ["🇲🇱","Mali"],
        ["🇲🇲","Myanmar (Burma)"],
        ["🇲🇳","Mongolia"],
        ["🇲🇴","Macau SAR China"],
        ["🇲🇵","Northern Mariana Islands"],
        ["🇲🇶","Martinique"],
        ["🇲🇷","Mauritania"],
        ["🇲🇸","Montserrat"],
        ["🇲🇹","Malta"],
        ["🇲🇺","Mauritius"],
        ["🇲🇻","Maldives"],
        ["🇲🇼","Malawi"],
        ["🇲🇽","Mexico"],
        ["🇲🇾","Malaysia"],
        ["🇲🇿","Mozambique"],
        ["🇳🇦","Namibia"],
        ["🇳🇨","New Caledonia"],
        ["🇳🇪","Niger"],
        ["🇳🇫","Norfolk Island"],
        ["🇳🇬","Nigeria"],
        ["🇳🇮","Nicaragua"],
        ["🇳🇱","Netherlands"],
        ["🇳🇴","Norway"],
        ["🇳🇵","Nepal"],
        ["🇳🇷","Nauru"],
        ["🇳🇺","Niue"],
        ["🇳🇿","New Zealand"],
        ["🇴🇲","Oman"],
        ["🇵🇦","Panama"],
        ["🇵🇪","Peru"],
        ["🇵🇫","French Polynesia"],
        ["🇵🇬","Papua New Guinea"],
        ["🇵🇭","Philippines"],
        ["🇵🇰","Pakistan"],
        ["🇵🇱","Poland"],
        ["🇵🇲","St. Pierre & Miquelon"],
        ["🇵🇳","Pitcairn Islands"],
        ["🇵🇷","Puerto Rico"],
        ["🇵🇸","Palestinian Territories"],
        ["🇵🇹","Portugal"],
        ["🇵🇼","Palau"],
        ["🇵🇾","Paraguay"],
        ["🇶🇦","Qatar"],
        ["🇷🇪","Réunion"],
        ["🇷🇴","Romania"],
        ["🇷🇸","Serbia"],
        ["🇷🇺","Russia"],
        ["🇷🇼","Rwanda"],
        ["🇸🇦","Saudi Arabia"],
        ["🇸🇧","Solomon Islands"],
        ["🇸🇨","Seychelles"],
        ["🇸🇩","Sudan"],
        ["🇸🇪","Sweden"],
        ["🇸🇬","Singapore"],
        ["🇸🇭","St. Helena"],
        ["🇸🇮","Slovenia"],
        ["🇸🇯","Svalbard & Jan Mayen"],
        ["🇸🇰","Slovakia"],
        ["🇸🇱","Sierra Leone"],
        ["🇸🇲","San Marino"],
        ["🇸🇳","Senegal"],
        ["🇸🇴","Somalia"],
        ["🇸🇷","Suriname"],
        ["🇸🇸","South Sudan"],
        ["🇸🇹","São Tomé & Príncipe"],
        ["🇸🇻","El Salvador"],
        ["🇸🇽","Sint Maarten"],
        ["🇸🇾","Syria"],
        ["🇸🇿","Swaziland"],
        ["🇹🇦","Tristan Da Cunha"],
        ["🇹🇨","Turks & Caicos Islands"],
        ["🇹🇩","Chad"],
        ["🇹🇫","French Southern Territories"],
        ["🇹🇬","Togo"],
        ["🇹🇭","Thailand"],
        ["🇹🇯","Tajikistan"],
        ["🇹🇰","Tokelau"],
        ["🇹🇱","Timor-Leste"],
        ["🇹🇲","Turkmenistan"],
        ["🇹🇳","Tunisia"],
        ["🇹🇴","Tonga"],
        ["🇹🇷","Turkey"],
        ["🇹🇹","Trinidad & Tobago"],
        ["🇹🇻","Tuvalu"],
        ["🇹🇼","Taiwan"],
        ["🇹🇿","Tanzania"],
        ["🇺🇦","Ukraine"],
        ["🇺🇬","Uganda"],
        ["🇺🇲","U.S. Outlying Islands"],
        ["🇺🇸","United States"],
        ["🇺🇾","Uruguay"],
        ["🇺🇿","Uzbekistan"],
        ["🇻🇦","Vatican City"],
        ["🇻🇨","St. Vincent & Grenadines"],
        ["🇻🇪","Venezuela"],
        ["🇻🇬","British Virgin Islands"],
        ["🇻🇮","U.S. Virgin Islands"],
        ["🇻🇳","Vietnam"],
        ["🇻🇺","Vanuatu"],
        ["🇼🇫","Wallis & Futuna"],
        ["🇼🇸","Samoa"],
        ["🇽🇰","Kosovo"],
        ["🇾🇪","Yemen"],
        ["🇾🇹","Mayotte"],
        ["🇿🇦","South Africa"],
        ["🇿🇲","Zambia"],
        ["🇿🇼","Zimbabwe"]
    ]
};



// WEBPACK FOOTER //
// ./app/utils/emoji-picker-icons.js